import script from "./AuditJobs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditJobs.vue?vue&type=script&lang=ts&setup=true"

import "./AuditJobs.vue?vue&type=style&index=0&id=7831b59d&scoped=true&lang=css"

import exportComponent from "../../../../../../ss/CO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7831b59d"]])

export default __exports__